import { permissionObj } from '../../../Helpers/permission';
import HeadTittle from '../../../components/HeadTittle';
import routes from '../../../Routes/routes';
import {AddIcon, QrIcon} from '../../../components/buttons/IconButtons';
import ButtonAction from '../../../components/buttons/ButtonAction';
import MaterialRequestTable from "./SubComponents/MaterialRequestTable";
import {MaterialRequestMainApp} from "./Functionality/MaterialRequestMainApp";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MaterialRequestMain = () => {
    const {
        navigate,
        permission,
        isGuard,
        DEV,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        option,
        setBodyForExport,
        isAllChecked,
        setIsAllChecked,
        selectedList,
        setSelectedList,
    } = MaterialRequestMainApp();

    if (!DEV && !permission?.includes(permissionObj?.WEB_MATERIAL_REQUEST_READ))
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'material_control'}>
                { isGuard &&
                    <ButtonAction
                        id='btn_mr_qr_scanner'
                        name='qr_scanner'
                        splitName={false}
                        className='btn-icon-accent-450'
                        Icon={QrIcon}
                        url={routes.materialRequest.scanner}
                    />
                }
                { DEV || permission?.includes(permissionObj?.WEB_MATERIAL_REQUEST_CREATE) &&
                    <ButtonAction
                        id='btn_mr_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        url={routes.materialRequest.create}
                    />
                }
            </HeadTittle>

            <MaterialRequestTable
                selectedList={selectedList}
                setSelectedList={setSelectedList}
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                option={option}
                setBodyForExport={setBodyForExport}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
            />
        </>
    );
};

export default MaterialRequestMain;
